import React from 'react';
import classNames from 'classnames';
import './StarRadioButton.scss';
    
const StarRadioButton = (props) => {
    const starLabelClasses = classNames('stars__label', {
        'checked': props.isChecked
    });

    return (
        <label
            className={starLabelClasses}
            htmlFor={props.radioButtonId}
            title={props.starRatingLabel}
        >
            <span className='stars__label__text'>
                {props.starRatingLabel}
            </span>
            <input
                checked={props.isChecked}
                className='stars__input'
                id={props.radioButtonId}
                name='rating'
                onChange={props.onChange}
                type='radio'
                value={props.starValue}
            />
        </label>
    );
};

export default StarRadioButton;



// WEBPACK FOOTER //
// ./application/components/StarRadioButton/StarRadioButton.jsx